<template>
    <el-dialog :visible.sync="dialogVisible" :top="top" :width="'1054px'" :lock-scroll="false" custom-class="assess-dialog" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
        <div class="dialog-p">
            <img :src="levelImg" class="dialog-bg" />
            <div class="dialog-num" :style="{color: levelColor}">{{ showPrice ? '¥' : ''}}{{ price }}</div>
        </div>
    </el-dialog>
</template>

<script>
export default {
    props: {
        showPrice: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            dialogVisible: false,
            price: '',
            levelColor: null,
            levelImg: null,
            top: '0px'
        }
    },
    methods: {
        showDialog(price, levelImg, levelColor) {
            let bodyHeight = document.body.clientHeight < document.documentElement.clientHeight ? document.body.clientHeight : document.documentElement.clientHeight - 833
            this.top = (bodyHeight > 0 ? bodyHeight : 0) / 2 + 'px'
            this.price = price
            this.levelImg = levelImg
            this.levelColor = levelColor
            this.dialogVisible = true
        }
    }
}
</script>

<style lang="scss">
.el-dialog__wrapper{
    overflow: hidden;
}
.assess-dialog{
    background: transparent;
    .el-dialog__headerbtn{
        z-index: 1;
    }
    .el-icon-close{
        font-size: 22px;
        color: #FFF;
    }
    .el-dialog__body{
        padding: 0;
    }
    .dialog-p{
        position: relative;
        .dialog-bg{
            width: 1054px;
            height: 833px;
        }
        .dialog-num{
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(342deg);
            font-size: 215px;
            white-space: nowrap;
            letter-spacing: 10px;
        }
    }
}
</style>
<style lang="scss" scoped>

// 进入动画
.dialog-fade-enter-active {
  animation: dialog-fade-in 1s;
}
// 离开动画
.dialog-fade-leave-active {
  animation: dialog-fade-out 1s;
}

@keyframes dialog-fade-in {
  0% {
    transform: scale(4);
    opacity: 0;
  }
  50% {
    transform: scale(4);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes dialog-fade-out {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(4);
    opacity: 0;
  }
  100% {
    transform: scale(4);
    opacity: 0;
  }
}

</style>